import { jsx } from "react/jsx-runtime";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { validateTidalLicense } from "../../base/index.js";
function PersonAdd(props) {
  return /* @__PURE__ */ jsx(
    PersonAddIcon,
    {
      "data-testid": "PersonAdd",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PersonAdd",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
PersonAdd.tidalIconMeta = {
  categories: "people,persona",
  name: "PersonAdd"
};
validateTidalLicense();
export {
  PersonAdd
};
//# sourceMappingURL=PersonAdd.js.map
